import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{faqData.title}</h2>
          <p className="text-sm text-foreground-500">{faqData.subtitle}</p>
        </div>
        <div className="space-y-3">
          {faqData.items.map((item, idx) => (
            <details key={idx} className="bg-background-50 border border-background-200 rounded-xl overflow-hidden group">
              <summary className="px-5 py-4 cursor-pointer flex items-center justify-between hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm md:text-base font-bold text-foreground-800 pr-4">{item.question}</h3>
                <span className="w-6 h-6 rounded-full bg-background-200 flex items-center justify-center shrink-0 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-foreground-600 text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}